import { render, staticRenderFns } from "./MarksEntryWithoutRubricsWWS.vue?vue&type=template&id=b5080d5c&scoped=true&"
import script from "./MarksEntryWithoutRubricsWWS.vue?vue&type=script&lang=js&"
export * from "./MarksEntryWithoutRubricsWWS.vue?vue&type=script&lang=js&"
import style0 from "./MarksEntryWithoutRubricsWWS.vue?vue&type=style&index=0&id=b5080d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5080d5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VChip,VCol,VDataTable,VRow,VSnackbar,VTextField})
